/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentProtocolEnum } from './VoiceAgentProtocolEnum';
import {
  VoiceAgentProtocolEnumFromJSON,
  VoiceAgentProtocolEnumFromJSONTyped,
  VoiceAgentProtocolEnumToJSON,
} from './VoiceAgentProtocolEnum';

/**
 * Polymorphic serializer base class.
 *
 * Note that the discriminator field must exist at the same depth as the mapped
 * serializer fields for the OpenAPI introspection. See
 * https://swagger.io/docs/specification/data-models/inheritance-and-polymorphism/ for
 * more information. As such, it's not possible to define something like:
 *
 * {
 *     "object_type": "foo",
 *     "polymorphic_context": {
 *         <foo-specific fields>
 *     }
 * }
 *
 * without explicitly wrapping this in a parent serializer, i.e. -
 * ``polymorphic_context`` can not be a PolymorphicSerializer itself, as it requires
 * access to the ``object_type`` in the parent scope.
 * @export
 * @interface PatchedVoiceAgentInferencerPolymorphicShared
 */
export interface PatchedVoiceAgentInferencerPolymorphicShared {
  /**
   *
   * @type {VoiceAgentProtocolEnum}
   * @memberof PatchedVoiceAgentInferencerPolymorphicShared
   */
  protocol?: VoiceAgentProtocolEnum;
}

/**
 * Check if a given object implements the PatchedVoiceAgentInferencerPolymorphicShared interface.
 */
export function instanceOfPatchedVoiceAgentInferencerPolymorphicShared(
  value: object,
): value is PatchedVoiceAgentInferencerPolymorphicShared {
  return true;
}

export function PatchedVoiceAgentInferencerPolymorphicSharedFromJSON(
  json: any,
): PatchedVoiceAgentInferencerPolymorphicShared {
  return PatchedVoiceAgentInferencerPolymorphicSharedFromJSONTyped(json, false);
}

export function PatchedVoiceAgentInferencerPolymorphicSharedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedVoiceAgentInferencerPolymorphicShared {
  if (json == null) {
    return json;
  }
  return {
    protocol: json['protocol'] == null ? undefined : VoiceAgentProtocolEnumFromJSON(json['protocol']),
  };
}

export function PatchedVoiceAgentInferencerPolymorphicSharedToJSON(
  value?: PatchedVoiceAgentInferencerPolymorphicShared | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: VoiceAgentProtocolEnumToJSON(value['protocol']),
  };
}
